<div id="main-content" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent($event)">
  <form *ngIf="employmentData ;  else loading" [formGroup]="employmentForm" (ngSubmit)="onSubmit()">

    <h1 #target class="bofa--heading is-4">Employment history</h1>

    <div *ngIf="employmentData.lockBox">
      <p>
        <mat-checkbox formControlName="noEmploymentHistory" aria-required="true">
          <mat-label><span class="white-space-normal">{{noEmploymentHistoryInstruction}}</span>
          </mat-label>
        </mat-checkbox>
      </p>
    </div>

    <div *ngIf="!noEmploymentHistory.value">
      <div [class.changeDisplay]="employmentChange" class="flex-container">
        <mat-card appearance="outlined" class="af-mat-card mat-elevation-z bottom-space fx-flex-50">
          <mat-card-header>
            <div mat-card-avatar class="example-header-image">
              <img alt="information" src="assets/bofa_icon_info.svg" class="img-size" role="img">
            </div>
            <mat-card-title>Account for all employment gaps</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p *ngIf="employmentData.employmentLimit != 55" class="bofa--heading is-9 global-red">The
              employment history must
              reflect all periods of employment or unemployment for the last {{employmentData.employmentLimit}} years,
              in chronological order, starting with your most recent job.</p>
            <p *ngIf="employmentData.employmentLimit == 55" class="bofa--heading is-9 global-red">Please
              enter 10 years of
              employment history, in chronological order, starting with your most recent job. If you are currently
              unemployed, enter that period of time as an Employment Break. Employment history must reflect all periods
              of employment or unemployment for the last 10 years.</p>

            <div *ngIf="employmentGapInstruction == 1 && employmentBreakList.length>0">
              <a target="_blank" rel="noopener noreferrer" (click)="clickEmploymentGapInstructions()"
                class="bold global-red" href="assets/OUS Employment Gap Instructions.docx"
                aria-label="employment gap instructions">Employment Gap Instructions </a>
            </div>
          </mat-card-content>
        </mat-card>


        <mat-card appearance="outlined" class="af-mat-card mat-elevation-z bottom-space fx-flex-50">
          <mat-card-header>
            <div mat-card-avatar class="example-header-image">
              <img alt="information" src="assets/bofa_icon_info.svg" class="img-size" role="img">
            </div>
            <mat-card-title>Currently unemployed?</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p class="bofa--heading is-9">Use the 'Add break' button to account for this period of time</p>
          </mat-card-content>
        </mat-card>
      </div>

      <div [class.changeDisplay]="employmentChange" class="flex-container">
        <div class="flex-change fx-flex-40">

          <h2 *ngIf="hasEmploymentHistory()" class="bofa--heading is-6 flex-heading">Enter your employment history
          </h2>

          <div *ngIf="jobCountry == 'IND'">
            <p>
              <span class="mat-hint-italic margin-notop minor-list-space">If you do not want us to initiate the
                verification for your most recent employment immediately, please select the date after which the
                employment verification should be initiated.
                <ul class="has-no-padding has-no-margin">
                  <li><strong>(This should be minimum 8 business days prior to the scheduled date of joining) Note:
                      Candidates will join only after a satisfactory employment verification report.)</strong> </li>
                </ul>
              </span>
            </p>
            <mat-form-field class="max-zoom field-space width-350">
              <input matInput [matDatepicker]="employmentVerificationDatePicker" time="false" [min]="minDate"
                formControlName="employmentVerificationDate" maxlength="100">
              <mat-datepicker-toggle matSuffix [for]="employmentVerificationDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #employmentVerificationDatePicker></mat-datepicker>
              <mat-hint>Format mm/dd/yyyy</mat-hint>
            </mat-form-field>

          </div>


          <div *ngFor="let employmentForm of employmentList.controls; let i = index" [formGroup]="employmentForm">
            <div>
              <mat-accordion multi="true" *ngIf="stepEmployment === i">
                <mat-expansion-panel [class.border]="borderEmpHistory" [expanded]="stepEmployment === i"
                  [hideToggle]="true" (opened)="setEmploymentStep(i)" class="af-mat-card mat-elevation-z panel-width">
                  <mat-expansion-panel-header class="mat-expansion outlined background-color-rgba">
                    <mat-panel-title>
                      Employer {{i + 1}}
                    </mat-panel-title>
                    <mat-panel-description>
                      <div class="float-cursor-margin">
                        <img role="button" class="height-width" src="assets/bofa_icon_close2_186rgb.svg" tabindex="0"
                          alt="remove employment" (click)="deleteEmploymentClick(i)"
                          (keyup.enter)="deleteEmploymentClick(i)" />
                      </div>
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <!-- set focus when pressing Add button -->
                  <div tabindex="-1" #addEmploymentHistoryElement class="bofa--skiplink">
                  </div>

                  <p class="bofa--heading is-8 bold ">(1 of {{sections}}) Important details</p>

                  <div class="bottom-space">
                    <div id="isCurrentEmployer-radio-group" class="minor-list-space"><span><abbr title="required">*
                        </abbr>Is this your current employer?</span>
                    </div>

                    <mat-radio-group aria-label="Select an option" class="bottom-space"
                      (focusout)="currentOnBlur(employmentForm)" (focusin)="currentOnFocus(employmentForm)"
                      aria-describedby="isCurrentEmployer-radio-group"
                      (change)="isCurrentEmployerChanges(employmentForm)" formControlName="isCurrentEmployer" required>
                      <mat-radio-button value="1" name="isCurrentEmployer"
                        class="minor-list-space radio-padding field-space">Yes</mat-radio-button>
                      <mat-radio-button value="0" name="isCurrentEmployer">No</mat-radio-button>
                      <mat-error
                        *ngIf="submit.value && employmentForm.controls.isCurrentEmployer.hasError('required') || employmentForm.controls.checkIsCurrentEmployer.value">
                        Please select Is this your current employer?</mat-error>
                    </mat-radio-group>
                  </div>

                  <div class="bottom-space" *ngIf="employmentForm.controls.isCurrentEmployer.value == 1">
                    <div id="isNoticePeriodRequired-radio-group" class="minor-list-space"><span><abbr title="required">*
                        </abbr>When you tender your resignation with your current employer, will you be required to work
                        a notice period before beginning employment with Bank of America?</span>
                    </div>
                    <mat-radio-group aria-label="Select an option" class="bottom-space"
                      (focusout)="haveNoticePeriodOnBlur(employmentForm)"
                      (focusin)="haveNoticePeriodOnFocus(employmentForm)"
                      aria-describedby="isNoticePeriodRequired-radio-group"
                      (change)="isNoticePeriodChange(employmentForm)" formControlName="noticePeriod" required>
                      <mat-radio-button value="1" name="noticePeriod"
                        class="minor-list-space radio-padding field-space">Yes
                      </mat-radio-button>
                      <mat-radio-button value="0" name="noticePeriod">No</mat-radio-button>
                      <mat-error
                        *ngIf="submit.value && employmentForm.controls.noticePeriod.hasError('required') || employmentForm.controls.checkNoticePeriod.value">
                        Please select When you tender your resignation with your current employer, will you be required
                        to work a notice period before beginning employment with Bank of America?</mat-error>
                    </mat-radio-group>
                  </div>


                  <div *ngIf="employmentForm.controls.noticePeriod.value == 1">
                    <!-- we need to ensure only for U.S condidate
                    apply that flag to show and hide the notice period question -->
                    <div class="bottom-space" *ngIf="true">
                      <mat-form-field hideRequiredMarker>
                        <mat-label id="noticePeriod-label"><abbr title="required">* </abbr><span>What is your required
                            notice period?(in
                            days)</span></mat-label>
                        <input matInput [value]="employmentForm.controls.noticePeriodDays.value"
                          formControlName="noticePeriodDays" type="text" maxlength="3" min="0" max="120" required
                          aria-labelledby="noticePeriod-label" aria-required="true">
                      </mat-form-field>
                      <mat-error role="alert"
                        *ngIf="!employmentForm.controls.noticePeriodDays.value && employmentForm.controls.noticePeriodDays.touched">
                        Please enter your notice period</mat-error>
                      <mat-error role="alert"
                        *ngIf="employmentForm.controls.noticePeriodDays.value && !employmentForm.controls.noticePeriodDays.valid">
                        Please enter valid notice period</mat-error>
                    </div>
                  </div>


                  <div *ngIf="employmentForm.controls.isCurrentEmployer.value == 1">
                    <div class="bottom-space">
                      <div id="canContactNow-radio-group" class="minor-list-space"><span><abbr title="required">*
                          </abbr>May we contact this employer?</span>
                      </div>

                      <mat-radio-group aria-label="Select an option" class="bottom-space"
                        aria-describedby="canContactNow-radio-group" (focusout)="canContactNowOnBlur(employmentForm)"
                        (focusin)="canContactNowOnFocus(employmentForm)" formControlName="canContactNow" required>
                        <mat-radio-button value="1" name="canContactNow"
                          class="minor-list-space radio-padding field-space">Yes</mat-radio-button>
                        <mat-radio-button value="0" name="canContactNow">No</mat-radio-button>
                        <mat-error
                          *ngIf="submit.value && employmentForm.controls.canContactNow.hasError('required') || employmentForm.controls.canContactNow.hasError('requireError') ||  employmentForm.controls.checkCanContactNow.value">
                          Please select May we contact this employer?</mat-error>
                      </mat-radio-group>
                    </div>
                  </div>

                  <div *ngIf="jobCountry != 'IND'">
                    <div class="bottom-space">
                      <div id="hasAgency-radio-group" class="minor-list-space"><span><abbr title="required">*
                          </abbr>While
                          working for this company, were you employed directly with
                          this company or by an agency?</span>
                      </div>

                      <mat-radio-group class="bottom-space" aria-describedby="hasAgency-radio-group"
                        (focusout)="hasAgencyOnBlur(employmentForm)" (focusin)="hasAgencyOnFocus(employmentForm)"
                        aria-label="Select an option" formControlName="hasAgency" required>
                        <mat-radio-button value="0" name="hasAgency" class="minor-list-space radio-padding field-space">
                          Directly for this company</mat-radio-button>
                        <mat-radio-button value="1" name="hasAgency">Agency</mat-radio-button>
                        <mat-error
                          *ngIf="submit.value && employmentForm.controls.hasAgency.hasError('required') || employmentForm.controls.checkhasAgency.value">
                          Please enter Agency information</mat-error>
                      </mat-radio-group>
                    </div>

                    <div *ngIf="employmentForm.controls.hasAgency.value == 1">
                      <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                        <mat-label><abbr title="required">* </abbr>Agency name</mat-label>
                        <input matInput formControlName="agencyName" required maxlength="250">
                        <mat-error>Please enter Agency name</mat-error>
                      </mat-form-field>

                      <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                        <mat-label><abbr title="required">* </abbr>Agency contact information</mat-label>
                        <input matInput formControlName="agencyContactDetails" required maxlength="250">
                        <mat-error>Please enter Agency contact information </mat-error>
                      </mat-form-field>

                      <mat-form-field class="width-margin max-zoom field-space" hideRequiredMarker>
                        <mat-label><abbr title="required">* </abbr>Agency address</mat-label>
                        <input matInput formControlName="agencyAddress" required maxlength="250">
                        <mat-error>Please enter Agency address information</mat-error>
                      </mat-form-field>
                    </div>
                  </div>


                  <mat-form-field *ngIf="jobCountry == 'IND'" class="max-zoom field-space width-350" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Nature of Employment</mat-label>
                    <mat-select formControlName="natureOfEmployment" required>
                      <mat-option>Select</mat-option>
                      <mat-option *ngFor="let empType of employmentData.natureOfEmploymentLookup | keyvalue"
                        [value]="empType.key">
                        {{empType.value}}
                      </mat-option>
                    </mat-select>
                    <mat-hint class="bofa--skiplink">
                      <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                      {{ dropDownScreenReaderNatureOfEmployment(employmentForm) }}
                    </mat-hint>
                    <mat-error *ngIf="employmentForm.controls.natureOfEmployment.hasError('required') ">Please select
                      Nature of Employment
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                    <mat-label> <abbr title="required">* </abbr>Date employment began</mat-label>
                    <input matInput [matDatepicker]="dateEmpBeganPicker" [min]="minDate" [max]="maxDate"
                      formControlName="employmentStartDate" required maxlength="100">
                    <mat-datepicker-toggle matSuffix [for]="dateEmpBeganPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateEmpBeganPicker></mat-datepicker>
                    <mat-hint>Format mm/dd/yyyy</mat-hint>
                    <mat-error *ngIf="employmentForm.controls.employmentStartDate.errors">
                      Please enter valid Date employment began</mat-error>
                  </mat-form-field>

                  <div *ngIf="employmentForm.controls.isCurrentEmployer.value == '0'">
                    <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                      <mat-label> <abbr title="required">* </abbr>Date employment ended</mat-label>
                      <input matInput [matDatepicker]="dateEmpEndedPicker" time="false" [min]="minDate" [max]="maxDate"
                        formControlName="employmentEndDate" required maxlength="100">
                      <mat-datepicker-toggle matSuffix [for]="dateEmpEndedPicker"></mat-datepicker-toggle>
                      <mat-datepicker #dateEmpEndedPicker></mat-datepicker>
                      <mat-hint>Format mm/dd/yyyy</mat-hint>
                      <mat-error *ngIf="employmentForm.controls.employmentEndDate.errors">
                        Please enter valid Date employment ended</mat-error>
                    </mat-form-field>
                  </div>

                  <p class="bofa--heading is-8 bold ">(2 of {{sections}}) General information</p>

                  <mat-form-field class="width-margin max-zoom field-space" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Employer/Company name</mat-label>
                    <input matInput formControlName="employerName" required maxlength="200">
                    <mat-error>Please enter Employer/Company name</mat-error>
                  </mat-form-field>

                  <mat-form-field class="width-margin max-zoom field-space" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Position/Title held</mat-label>
                    <input matInput formControlName="position" required maxlength="200">
                    <mat-error>Please enter Position/Title held</mat-error>
                  </mat-form-field>

                  <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Type of employment</mat-label>
                    <mat-select formControlName="employmentType" required>
                      <mat-option>Select</mat-option>
                      <mat-option *ngFor="let empType of employmentData.typeOfEmploymentLookup | keyvalue"
                        [value]="empType.key">
                        {{empType.value}}
                      </mat-option>
                    </mat-select>
                    <mat-hint class="bofa--skiplink">
                      <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                      {{ dropDownScreenReaderTypeOfEmployment(employmentForm) }}
                    </mat-hint>
                    <mat-error *ngIf="employmentForm.controls.employmentType.hasError('required') ">Please select Type
                      of employment
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="max-zoom field-space width-margin" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Type of employer</mat-label>
                    <mat-select formControlName="businessTypeEmployer" required>
                      <mat-option>Select</mat-option>
                      <mat-option
                        *ngFor="let employerType of employmentData.typeOfEmployerLookup | keyvalue : valueAscOrderOtherLast"
                        [value]="employerType.key">
                        {{employerType.value}}
                      </mat-option>
                    </mat-select>
                    <mat-hint class="bofa--skiplink">
                      <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                      {{ dropDownScreenReaderBusinessTypeEmployer(employmentForm) }}
                    </mat-hint>
                    <mat-error *ngIf="employmentForm.controls.businessTypeEmployer.hasError('required') ">Please select
                      Type of employer</mat-error>
                  </mat-form-field>

                  <mat-form-field class="max-zoom field-space width-margin" hideRequiredMarker>
                    <mat-label><abbr *ngIf="jobCountry != 'IND'" title="required">* </abbr>Brief description of job
                      responsibilities</mat-label>
                    <textarea matInput formControlName="workDescription" maxlength="1000"></textarea>
                    <mat-hint align="end">
                      {{(employmentForm.controls.workDescription.value)?employmentForm.controls.workDescription.value.length:0}}
                      / 1000</mat-hint>
                    <mat-error>Please enter Responsibilities</mat-error>
                  </mat-form-field>

                  <mat-form-field *ngIf="employmentForm.controls.isCurrentEmployer.value == 0"
                    class="max-zoom field-space width-350" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Reason for Leaving</mat-label>
                    <mat-select formControlName="reason" required
                      (selectionChange)="onReasonChange($event ,employmentForm.controls.reasonCodeForLeavingLookup )">
                      <mat-option>Select</mat-option>
                      <mat-option *ngFor="let reason of employmentData.reasonForLeavingLookup | keyvalue"
                        [value]="reason.key">
                        {{reason.value}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="employmentForm.controls.reason.hasError('required') ">Please select Reason for
                      Leaving
                    </mat-error>
                    <mat-hint class="bofa--skiplink">
                      <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                      {{ dropDownScreenReaderReasonForLeaving(employmentForm) }}
                    </mat-hint>
                  </mat-form-field>

                  <mat-form-field *ngIf="employmentForm.controls.isCurrentEmployer.value == 0"
                    class="max-zoom field-space width-350" hideRequiredMarker>
                    <mat-label><abbr *ngIf="jobCountry != 'IND'" title="required">* </abbr>Reason Code for Leaving
                    </mat-label>
                    <mat-select formControlName="reasonCode">
                      <mat-option>Select</mat-option>
                      <mat-option
                        *ngFor="let reasonCode of employmentForm.controls.reasonCodeForLeavingLookup.value | keyvalue : valueAscOrderOtherLast"
                        [value]="reasonCode.key">
                        {{reasonCode.value}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="employmentForm.controls.reasonCode.hasError('required') ">Please enter Reason Code
                      for Leaving.
                    </mat-error>
                    <mat-hint class="bofa--skiplink">
                      <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                      {{ dropDownScreenReaderReasonCode(employmentForm) }}
                    </mat-hint>
                  </mat-form-field>

                  <mat-form-field *ngIf="employmentForm.controls.isCurrentEmployer.value == 0"
                    class="max-zoom field-space width-margin" hideRequiredMarker>
                    <mat-label><abbr *ngIf="jobCountry != 'IND'" title="required">* </abbr>Additional Details regarding
                      Reason for Leaving
                    </mat-label>
                    <textarea matInput formControlName="addnlDetailsForRFL"></textarea>
                    <mat-hint align="end">
                      {{(employmentForm.controls.addnlDetailsForRFL.value)?employmentForm.controls.addnlDetailsForRFL.value.length:0}}
                      / 1000</mat-hint>
                    <mat-error>Please enter Additional Details</mat-error>
                  </mat-form-field>

                  <div class="non-required" *ngIf="jobCountry == 'IND'">
                    <mat-form-field class="max-width width-310">
                      <mat-label>Current Remuneration (Per Annum) (optional)</mat-label>
                      <input matInput formControlName="currentRemunaration" maxlength="200">
                    </mat-form-field>
                  </div>

                  <div *ngIf="jobCountry == 'IND'">
                    <mat-radio-group class="bottom-space minor-radio-padding" formControlName="fixedOrVariable">
                      <mat-radio-button class="minor-list-space radio-padding field-space" matInput [value]=0
                        name="fixedOrVariable">Fixed</mat-radio-button>
                      <mat-radio-button class="minor-radio-padding" matInput [value]=1 name="fixedOrVariable">Variable
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>


                  <p class="bofa--heading is-8 bold ">(3 of {{sections}}) Employer information</p>

                  <mat-form-field class="max-zoom field-space width-margin" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Employer street address</mat-label>
                    <input matInput formControlName="streetAddressOne" required maxlength="100">
                    <mat-error>Please enter Employer street address</mat-error>
                  </mat-form-field>

                  <div class="non-required bottom-space">
                    <mat-form-field class="max-width width-350">
                      <mat-label>More street address (if applicable)</mat-label>
                      <input matInput formControlName="streetAddressTwo" maxlength="150">
                    </mat-form-field>
                  </div>

                  <div class="non-required bottom-space">
                    <mat-form-field class="max-width width-350">
                      <mat-label>More street address (if applicable)</mat-label>
                      <input matInput formControlName="streetAddressThree" maxlength="255">
                    </mat-form-field>
                  </div>

                  <mat-form-field class="max-zoom field-space width-margin" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Employer Zip / Postal code</mat-label>
                    <input matInput formControlName="zipCode" required maxlength="13">
                    <mat-error>Please enter Employer Zip / Postal code</mat-error>
                  </mat-form-field>

                  <mat-form-field class="max-zoom field-space width-margin" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Employer Town/City/Province</mat-label>
                    <input matInput formControlName="city" required maxlength="100">
                    <mat-error>Please enter Employer Town/City/Province</mat-error>
                  </mat-form-field>

                  <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Employer Country</mat-label>
                    <mat-select formControlName="country" required>
                      <mat-option>Select</mat-option>
                      <mat-option *ngFor="let country of employmentData.countryLookup | keyvalue : valueAscOrder"
                        [value]="country.key">
                        {{country.value}}
                      </mat-option>
                    </mat-select>
                    <mat-hint class="bofa--skiplink">
                      <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                      {{ dropDownScreenReaderCountry(employmentForm) }}
                    </mat-hint>
                    <mat-error *ngIf="employmentForm.controls.country.hasError('required') ">Please select Employer
                      Country
                    </mat-error>
                  </mat-form-field>

                  <div *ngIf="employmentForm.controls.country.value == 186">
                    <mat-form-field class="max-zoom field-space width-margin-25" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Employer State/Region</mat-label>
                      <mat-select formControlName="usState" required>
                        <mat-option>Select</mat-option>
                        <mat-option *ngFor="let usState of employmentData.usStateLookup | keyvalue : valueAscOrder"
                          [value]="usState.key">
                          {{usState.value}}
                        </mat-option>
                      </mat-select>
                      <mat-hint class="bofa--skiplink">
                        <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                        {{ dropDownScreenReaderState(employmentForm) }}
                      </mat-hint>
                      <mat-error
                        *ngIf="employmentForm.controls.usState.hasError('required') || employmentForm.controls.usState.hasError('requireError')">
                        Please enter Employer State/Region </mat-error>
                    </mat-form-field>
                  </div>
                  <div *ngIf="employmentForm.controls.country.value != 186">
                    <mat-form-field class="max-zoom field-space width-margin-25" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Employer State/Region</mat-label>
                      <input matInput formControlName="state" required maxlength="100">
                      <mat-error>Please enter Employer State/Region</mat-error>
                    </mat-form-field>
                  </div>

                  <mat-form-field *ngIf="jobCountry == 'IND'" class="max-zoom field-space width-margin-1"
                    hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Employer phone number</mat-label>
                    <input matInput formControlName="businessPhoneNumber" required maxlength="30" minlength="9">
                    <mat-error *ngIf="employmentForm.controls.businessPhoneNumber.errors">Please enter a valid Phone
                      number
                    </mat-error>
                  </mat-form-field>

                  <div *ngIf="jobCountry != 'IND'" class="non-required">
                    <mat-form-field class="max-width width-310">
                      <mat-label>Employer phone number (optional)</mat-label>
                      <input matInput formControlName="businessPhoneNumber" maxlength="30">
                      <mat-error>Please enter a valid Phone number</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="non-required">
                    <mat-form-field class="max-width width-310">
                      <mat-label>Employer website (optional)</mat-label>
                      <input matInput formControlName="employerWebsite" maxlength="100">
                    </mat-form-field>
                  </div>

                  <p class="bofa--heading is-8 bold ">(4 of {{sections}}) Manager information</p>

                  <mat-form-field class="max-zoom field-space width-margin-25" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Manager's full name</mat-label>
                    <input matInput formControlName="managerName" required maxlength="200">
                    <mat-error>Please enter the Manager's full name</mat-error>
                  </mat-form-field>

                  <mat-form-field class="max-zoom field-space width-margin-1" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Manager's phone number</mat-label>
                    <input matInput formControlName="managerPhoneNumber" required maxlength="30" minlength="9">
                    <mat-error *ngIf="employmentForm.controls.managerPhoneNumber.errors">Please
                      enter your Manager's phone number including the area code (minimum of 10 characters required)
                    </mat-error>
                  </mat-form-field>

                  <div class="non-required">
                    <mat-form-field class="max-width width-310">
                      <mat-label>Manager's email address (optional)</mat-label>
                      <input matInput formControlName="managerEmailAddress" maxlength="200">
                    </mat-form-field>
                  </div>
                  <div *ngIf="jobCountry == 'IND'">
                    <div class="margin-top-1">
                      <div class="bottom-space">
                        <div id="managerStillEmployed-radio-group" class="minor-list-space"><span><abbr
                              title="required">* </abbr>Is Manager Still Part of the Company? </span>
                        </div>
                        <mat-radio-group aria-describedby="managerStillEmployed-radio-group"
                          aria-label="Select an option" formControlName="managerStillEmployed">
                          <mat-radio-button value="1" name="managerStillEmployed"
                            class="minor-list-space radio-padding field-space">Yes</mat-radio-button>
                          <mat-radio-button value="0" name="managerStillEmployed">No
                          </mat-radio-button>
                          <mat-error
                            *ngIf="submit.value && employmentForm.controls.managerStillEmployed.hasError('required') ">
                            Please enter Is Manager Still Part of the Company?
                          </mat-error>
                        </mat-radio-group>
                      </div>
                    </div>

                    <mat-form-field class="max-zoom field-space width-margin-1" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Manager's Designation </mat-label>
                      <input matInput formControlName="managerDesignation" required>
                      <mat-error *ngIf="employmentForm.controls.managerDesignation.errors">Please
                        enter your Manager's Designation
                      </mat-error>
                    </mat-form-field>

                  </div>

                  <p class="bofa--heading is-8 bold" *ngIf="jobCountry == 'IND'">(5 of {{sections}}) Document
                    Information</p>

                  <div class="bottom-space" *ngIf="jobCountry == 'IND'">
                    <div id="required-documents" class="minor-list-space">
                      <span *ngIf="employmentForm.controls.isCurrentEmployer.value == 1"> Accepted Documentation for
                        Current Employment</span>
                      <span *ngIf="employmentForm.controls.isCurrentEmployer.value == 0"> Accepted Documentation for
                        Previous Employment</span>
                    </div>

                    <!-- current employer -->

                    <div class="bottom-space" *ngIf="employmentForm.controls.isCurrentEmployer.value == 1"
                      hideRequiredMarker>
                      <p id="currDateOfJoiningProofLabel"><abbr title="required">*</abbr> Date of Joining proof </p>
                      <button type="button" (click)="fileInput1.click()" mat-raised-button>Choose file</button>
                      <input formControlName="currentDojProof" hidden type="file"
                        (change)="onFileSelected($event,0,'currentDojProofId',i)" id="current-doj-document"
                        aria-labelledby="currDateOfJoiningProofLabel" #fileInput1 />
                      <input formControlName="currentDojProofId" hidden type="text" id="current-doj-id"
                        aria-labelledby="currDateOfJoiningProofLabel" aria-required="true" required />
                      <span class="file-name">{{selectedFile[i][0]?.name}}</span>
                      <button *ngIf="selectedFile[i][0]?.name!=null" type="button" aria-label="delete the attachment"
                        class="close-button">
                        <mat-icon class="global-red" (keyup.enter)="removeAttachment($event,i,0,'currentDojProofId')"
                          (click)="removeAttachment($event,i,0,'currentDojProofId')">cancel</mat-icon>
                      </button>
                      <mat-error
                        *ngIf="(submit.value && !employmentForm.controls.currentDojProofId.value) || (employmentForm.controls.currentDojProof.dirty && !employmentForm.controls.currentDojProofId.value)">
                        Please attach a file
                      </mat-error>
                    </div>

                    <div class="bottom-space" *ngIf="employmentForm.controls.isCurrentEmployer.value == 1">
                      <p id="currDesiginationProofLabel"><abbr title="required">*</abbr> Designation proof </p>
                      <button type="button" (click)="fileInput2.click()" mat-raised-button>Choose file</button>
                      <input formControlName="currentDesignationProof" hidden type="file"
                        (change)="onFileSelected($event,1,'currentDesignationProofId',i)"
                        id="current-designation-document" aria-labelledby="currDesiginationProofLabel" #fileInput2 />
                      <input formControlName="currentDesignationProofId" hidden type="text"
                        id="current-designation-document-id" aria-labelledby="currDesiginationProofLabel"
                        aria-required="true" required />
                      <span class="file-name">{{selectedFile[i][1]?.name}}</span>
                      <button *ngIf="selectedFile[i][1]?.name!=null" type="button" aria-label="delete the attachment"
                        class="close-button">
                        <mat-icon class="global-red"
                          (keyup.enter)="removeAttachment($event,i,1,'currentDesignationProofId')"
                          (click)="removeAttachment($event,i,1,'currentDesignationProofId')">cancel</mat-icon>
                      </button>
                      <mat-error
                        *ngIf="(submit.value && !employmentForm.controls.currentDesignationProofId.value) ||  (employmentForm.controls.currentDesignationProof.dirty && !employmentForm.controls.currentDesignationProofId.value)">
                        Please attach a file
                      </mat-error>
                    </div>

                    <div class="bottom-space" *ngIf="employmentForm.controls.isCurrentEmployer.value == 1">
                      <p id="currOfferLetterLabel"> Offer Letter </p>
                      <button type="button" (click)="fileInput3.click()" mat-raised-button>Choose file</button>
                      <input formControlName="currentOfferLetter" hidden type="file"
                        (change)="onFileSelected($event,2,'currentOfferLetterId',i)" id="current-offer" #fileInput3
                        aria-labelledby="currOfferLetterLabel" />
                      <input formControlName="currentOfferLetterId" hidden type="text" id="current-offer-id"
                        aria-labelledby="currOfferLetterLabel" aria-required="false" />
                      <span class="file-name">{{selectedFile[i][2]?.name}}</span>
                      <button *ngIf="selectedFile[i][2]?.name!=null" type="button" aria-label="delete the attachment"
                        class="close-button">
                        <mat-icon class="global-red" (keyup.enter)="removeAttachment($event,i,2,'currentOfferLetterId')"
                          (click)="removeAttachment($event,i,2,'currentOfferLetterId')">cancel</mat-icon>
                      </button>
                    </div>

                    <div class="bottom-space" *ngIf="employmentForm.controls.isCurrentEmployer.value == 1">
                      <p id="currCompensationLetterLabel"> Compensation Letter </p>
                      <button type="button" (click)="fileInput4.click()" mat-raised-button>Choose file</button>
                      <input formControlName="currentCompensationLetter" hidden type="file"
                        (change)="onFileSelected($event,3,'currentCompensationLetterId',i)" id="current-compensation"
                        aria-labelledby="currCompensationLetterLabel" #fileInput4 />
                      <input formControlName="currentCompensationLetterId" hidden type="text"
                        id="current-compensation-id" aria-labelledby="currCompensationLetterLabel"
                        aria-required="false" />
                      <span class="file-name">{{selectedFile[i][3]?.name}}</span>
                      <button *ngIf="selectedFile[i][3]?.name!=null" type="button" aria-label="delete the attachment"
                        class="close-button">
                        <mat-icon class="global-red"
                          (keyup.enter)="removeAttachment($event,i,3,'currentCompensationLetterId')"
                          (click)="removeAttachment($event,i,3,'currentCompensationLetterId')">cancel</mat-icon>
                      </button>
                    </div>

                    <div class="bottom-space" *ngIf="employmentForm.controls.isCurrentEmployer.value == 1">
                      <p id="currLatestSalarySlipsLabel"> Three latest salary slips </p>
                      <button type="button" (click)="fileInput5.click()" mat-raised-button>Choose file</button>
                      <input formControlName="currentLatestThreePaySlip" hidden type="file"
                        (change)="onFileSelected($event,4,'currentLatestThreePaySlipId',i)" id="current-payslip"
                        aria-labelledby="currLatestSalarySlipsLabel" #fileInput5 />
                      <input formControlName="currentLatestThreePaySlipId" hidden type="text" id="current-payslip-id"
                        aria-labelledby="currLatestSalarySlipsLabel" aria-required="false" />
                      <span class="file-name">{{selectedFile[i][4]?.name}}</span>
                      <button *ngIf="selectedFile[i][4]?.name!=null" type="button" aria-label="delete the attachment"
                        class="close-button">
                        <mat-icon class="global-red"
                          (keyup.enter)="removeAttachment($event,i,4,'currentLatestThreePaySlipId')"
                          (click)="removeAttachment($event,i,4,'currentLatestThreePaySlipId')">cancel</mat-icon>
                      </button>
                    </div>


                    <!-- Previous Employer -->

                    <div class="bottom-space" *ngIf="employmentForm.controls.isCurrentEmployer.value == 0"
                      hideRequiredMarker>
                      <p id="prevDateOfJoiningProofLabel"><abbr title="required">*</abbr> Date of Joining proof </p>
                      <button type="button" (click)="fileInput6.click()" mat-raised-button>Choose file</button>
                      <input formControlName="previousDojProof" hidden type="file"
                        (change)="onFileSelected($event,5,'previousDojProofId',i)" id="previous-doj-document"
                        aria-labelledby="prevDateOfJoiningProofLabel" #fileInput6 />
                      <input formControlName="previousDojProofId" hidden type="text" id="previous-doj-document-id"
                        aria-labelledby="prevDateOfJoiningProofLabel" aria-required="true" required />
                      <span class="file-name">{{selectedFile[i][5]?.name}}</span>
                      <button *ngIf="selectedFile[i][5]?.name!=null" type="button" aria-label="delete the attachment"
                        class="close-button">
                        <mat-icon class="global-red" (keyup.enter)="removeAttachment($event,i,5,'previousDojProofId')"
                          (click)="removeAttachment($event,i,5,'previousDojProofId')">cancel</mat-icon>
                      </button>
                      <mat-error
                        *ngIf="(submit.value && !employmentForm.controls.previousDojProofId.value) || !employmentForm.controls.previousDojProofId.value && employmentForm.controls.previousDojProof.dirty">
                        Please attach a file
                      </mat-error>
                    </div>

                    <div class="bottom-space" *ngIf="employmentForm.controls.isCurrentEmployer.value == 0"
                      hideRequiredMarker>
                      <p id="prevDesiginationProofLabel"><abbr title="required">*</abbr> Designation proof </p>
                      <button type="button" (click)="fileInput7.click()" mat-raised-button>Choose file</button>
                      <input formControlName="previousDesignationProof" hidden type="file"
                        (change)="onFileSelected($event,6,'previousDesignationProofId',i)"
                        id="previous-designation-document" aria-labelledby="prevDesiginationProofLabel" #fileInput7 />
                      <input formControlName="previousDesignationProofId" hidden type="text"
                        id="previous-designation-document-id" aria-labelledby="prevDesiginationProofLabel"
                        aria-required="true" required />
                      <span class="file-name">{{selectedFile[i][6]?.name}}</span>
                      <button *ngIf="selectedFile[i][6]?.name!=null" type="button" aria-label="delete the attachment"
                        class="close-button">
                        <mat-icon class="global-red"
                          (keyup.enter)="removeAttachment($event,i,6,'previousDesignationProofId')"
                          (click)="removeAttachment($event,i,6,'previousDesignationProofId')">cancel</mat-icon>
                      </button>
                      <mat-error
                        *ngIf="(submit.value && !employmentForm.controls.previousDesignationProofId.value) || (!employmentForm.controls.previousDesignationProofId.value && employmentForm.controls.previousDesignationProof.dirty)">
                        Please attach a file
                      </mat-error>
                    </div>

                    <div class="bottom-space" *ngIf="employmentForm.controls.isCurrentEmployer.value == 0"
                      hideRequiredMarker>
                      <p id="lastDayWorkingLabel"><abbr title="required">*</abbr> Last Working Day proof (Relieving
                        Letter/FnF) </p>
                      <button type="button" (click)="fileInput8.click()" mat-raised-button>Choose file</button>
                      <input formControlName="lwdProof" hidden type="file"
                        (change)="onFileSelected($event,7,'lwdProofId',i)" id="lwd-document"
                        aria-labelledby="lastDayWorkingLabel" #fileInput8 />
                      <input formControlName="lwdProofId" hidden type="text" id="lwd-document-id"
                        aria-labelledby="lastDayWorkingLabel" aria-required="true" required />
                      <span class="file-name">{{selectedFile[i][7]?.name}}</span>
                      <button *ngIf="selectedFile[i][7]?.name!=null" type="button" aria-label="delete the attachment"
                        class="close-button">
                        <mat-icon class="global-red" (keyup.enter)="removeAttachment($event,i,7,'lwdProofId')"
                          (click)="removeAttachment($event,i,7,'lwdProofId')">cancel</mat-icon>
                      </button>
                      <mat-error
                        *ngIf="(submit.value && !employmentForm.controls.lwdProofId.value) ||(!employmentForm.controls.lwdProofId.value && employmentForm.controls.lwdProof.dirty) ">
                        Please attach a file
                      </mat-error>
                    </div>

                    <div class="bottom-space" *ngIf="employmentForm.controls.isCurrentEmployer.value == 0">
                      <p id="prevOfferLetter"> Offer Letter </p>
                      <button type="button" (click)="fileInput9.click()" mat-raised-button>Choose file</button>
                      <input formControlName="previousOfferLetter" hidden type="file"
                        (change)="onFileSelected($event,8,'previousOfferLetterId',i)" id="previous-offer-letter"
                        aria-labelledby="prevOfferLetter" #fileInput9 />
                      <input formControlName="previousOfferLetterId" hidden type="text" id="previous-offer-letter-id"
                        aria-labelledby="prevOfferLetter" aria-required="false" />
                      <span class="file-name">{{selectedFile[i][8]?.name}}</span>
                      <button *ngIf="selectedFile[i][8]?.name!=null" type="button" aria-label="delete the attachment"
                        class="close-button">
                        <mat-icon class="global-red"
                          (keyup.enter)="removeAttachment($event,i,8,'previousOfferLetterId')"
                          (click)="removeAttachment($event,i,8,'previousOfferLetterId')">cancel</mat-icon>
                      </button>
                    </div>

                    <div class="bottom-space" *ngIf="employmentForm.controls.isCurrentEmployer.value == 0">
                      <p id="prevCompensationLetterLabel"> Compensation Letter </p>
                      <button type="button" (click)="fileInput10.click()" mat-raised-button>Choose file</button>
                      <input formControlName="previousCompensationLetter" hidden type="file"
                        (change)="onFileSelected($event,9,'previousCompensationLetterId',i)" id="previous-compensation"
                        aria-labelledby="prevCompensationLetterLabel" #fileInput10 />
                      <input formControlName="previousCompensationLetterId" hidden type="text"
                        id="previous-compensation-id" aria-labelledby="prevCompensationLetterLabel"
                        aria-required="false" />
                      <span class="file-name">{{selectedFile[i][9]?.name}}</span>
                      <button *ngIf="selectedFile[i][9]?.name!=null" type="button" aria-label="delete the attachment"
                        class="close-button">
                        <mat-icon class="global-red"
                          (keyup.enter)="removeAttachment($event,i,9,'previousCompensationLetterId')"
                          (click)="removeAttachment($event,i,9,'previousCompensationLetterId')">cancel</mat-icon>
                      </button>
                    </div>

                    <div class="bottom-space" *ngIf="employmentForm.controls.isCurrentEmployer.value == 0">
                      <p id="prevLatestSalarySlips"> Three latest salary slips </p>
                      <button type="button" (click)="fileInput11.click()" mat-raised-button>Choose file</button>
                      <input formControlName="previousLastThreeMonthPaySlip" hidden type="file"
                        (change)="onFileSelected($event,10,'previousLastThreeMonthPaySlipId',i)" id="previous-payslip"
                        aria-labelledby="prevLatestSalarySlips" #fileInput11 />
                      <input formControlName="previousLastThreeMonthPaySlipId" hidden type="text"
                        id="previous-payslip-id" aria-labelledby="prevLatestSalarySlips" aria-required="false" />
                      <span class="file-name">{{selectedFile[i][10]?.name }}</span>
                      <button *ngIf="selectedFile[i][10]?.name!=null" type="button" aria-label="delete the attachment"
                        class="close-button">
                        <mat-icon class="global-red"
                          (keyup.enter)="removeAttachment($event,i,10,'previousLastThreeMonthPaySlipId')"
                          (click)="removeAttachment($event,i,10,'previousLastThreeMonthPaySlipId')">cancel</mat-icon>
                      </button>
                    </div>

                  </div>


                  <div class="is-taller remove-button-align">
                    <button type="button" class="bofa--button primary outlined"
                      (click)="deleteEmploymentClick(i)">Remove this employer</button>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>

          <div #target2 class="is-taller">
            <div class="level">
              <div class="level-item">
                <h2 *ngIf="hasEmploymentBreakHistory()" class="bofa--heading is-6">Enter your employment break
                  history</h2>
              </div>
            </div>
          </div>

          <div *ngFor="let employmentForm of employmentBreakList.controls; let i = index" [formGroup]="employmentForm">
            <mat-accordion multi="true" *ngIf="stepEmploymentBreak === i">
              <mat-expansion-panel [class.border]="borderEmpBreak" [expanded]="stepEmploymentBreak === i"
                [hideToggle]="true" (opened)="setEmploymentBreakStep(i)"
                class="af-mat-card mat-elevation-z panel-width">
                <mat-expansion-panel-header class="mat-expansion outlined background-color-rgba">
                  <mat-panel-title>
                    Employment Break {{i + 1}}
                  </mat-panel-title>
                  <mat-panel-description>
                    <div class="float-cursor-margin">
                      <img role="img" src="assets/bofa_icon_close2_186rgb.svg" tabindex="0" class="height-width"
                        alt="remove employment break" (click)="deleteEmploymentBreakClick(i)"
                        (keyup.enter)="deleteEmploymentBreakClick(i)" />
                    </div>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <!-- set focus when pressing Add button -->
                <div tabindex="-1" #addEmploymentBreakElement class="bofa--skiplink">
                </div>

                <div class="margin-top-1">
                  <div class="bottom-space">
                    <div id="isCurrentEmploymentStatus-radio-group" class="minor-list-space"><span><abbr
                          title="required">* </abbr>Is this your current employment
                        status?</span>
                    </div>
                    <mat-radio-group aria-describedby="isCurrentEmploymentStatus-radio-group"
                      aria-label="Select an option" (focusout)="isCurrentEmploymentStatusOnBlur(employmentForm)"
                      (focusin)="isCurrentEmploymentStatusOnFocus(employmentForm)"
                      formControlName="isCurrentEmploymentStatus">
                      <mat-radio-button value="1" name="isCurrentEmploymentStatus"
                        class="minor-list-space radio-padding field-space">Yes</mat-radio-button>
                      <mat-radio-button value="0" name="isCurrentEmploymentStatus">No
                      </mat-radio-button>
                      <mat-error
                        *ngIf="submit.value && employmentForm.controls.isCurrentEmploymentStatus.hasError('required') ||  employmentForm.controls.checkisCurrentEmploymentStatus.value">
                        Please enter Is this your current employment status?
                      </mat-error>
                    </mat-radio-group>
                  </div>
                </div>

                <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                  <mat-label> <abbr title="required">* </abbr>Date break in employment began</mat-label>
                  <input matInput [matDatepicker]="dateBreakBeganPicker" [min]="minDate" [max]="maxDate"
                    formControlName="employmentBreakFromDate" required maxlength="100">
                  <mat-datepicker-toggle matSuffix [for]="dateBreakBeganPicker"></mat-datepicker-toggle>
                  <mat-datepicker #dateBreakBeganPicker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  <mat-error *ngIf="employmentForm.controls.employmentBreakFromDate.errors">
                    Please enter valid Date break began</mat-error>
                </mat-form-field>

                <div *ngIf="employmentForm.controls.isCurrentEmploymentStatus.value == '0'">
                  <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                    <mat-label> <abbr title="required">* </abbr>Date break in employment ended</mat-label>
                    <input matInput [matDatepicker]="dateBreakEndedPicker" [min]="minDate" [max]="maxDate"
                      formControlName="employmentBreakToDate" required maxlength="100">
                    <mat-datepicker-toggle matSuffix [for]="dateBreakEndedPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateBreakEndedPicker></mat-datepicker>
                    <mat-hint>Format mm/dd/yyyy</mat-hint>
                    <mat-error *ngIf="employmentForm.controls.employmentBreakFromDate.errors">
                      Please enter valid Date break ended</mat-error>
                  </mat-form-field>
                </div>

                <mat-form-field class="max-zoom field-space width-margin-25" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Reason for break in employment</mat-label>
                  <mat-select formControlName="employmentBreakReason" required>
                    <mat-option>Select</mat-option>
                    <mat-option *ngFor="let empBreakLookup of employmentData.reasonEmploymentBreakLookup | keyvalue"
                      [value]="empBreakLookup.key">
                      {{empBreakLookup.value}}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="bofa--skiplink">
                    <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                    {{ dropDownScreenReaderemploymentBreakReason(employmentForm) }}
                  </mat-hint>
                  <mat-error *ngIf="employmentForm.controls.employmentBreakReason.hasError('required') ">Please select
                    Reason for break in employment</mat-error>
                </mat-form-field>

                <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                  <mat-label id="emp-break-comments-label"><abbr title="required">* </abbr>Comments</mat-label>
                  <textarea matInput formControlName="employmentBreakComment" required maxlength="1000"
                    aria-labelledby="emp-break-comments-label"></textarea>
                  <mat-hint align="end">
                    {{(employmentForm.controls.employmentBreakComment.value)?employmentForm.controls.employmentBreakComment.value.length:0}}
                    / 1000</mat-hint>
                  <mat-error>Please enter Comments</mat-error>
                </mat-form-field>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>

        <!-- Horizontal view -->
        <div *ngIf="!employmentChange" class="fx-flex-60">
          <div [class.sticky]="sticky" class="max-width-535" [style.overflow]="'auto'" #stickyDiv>
            <div class="is-taller">
              <div class="level">
                <div class="width-padding-left" id="review-employment-horizontal">
                  <span *ngIf="hasEmploymentHistory()" class="bofa--heading is-6">Review your employment history</span>
                </div>
                <div class="width-padding-left-305"> <button [disabled]="employmentBreakList.invalid" type="button"
                    class="bofa--button secondary outlined float-padding-margin" #addBreakButtonElement
                    (click)="onAddBreak(); scroll(target2)">Add
                    break</button>
                </div>
                <div class="width-padding-left-305"> <button [disabled]="employmentList.invalid" type="button"
                    class="bofa--button secondary button-font-flex float-padding-margin" #addHistoryButtonElement
                    (click)="onAddEmployer(target); scroll(target)">Add
                    employer</button>
                </div>
              </div>
            </div>
            <div>
              <mat-selection-list *ngIf="listCheckEmploymentHistory"
                (selectionChange)="handleEmploymentSelection($event, i)">
                <mat-list-option *ngFor="let employmentForm of employmentList.controls; let i = index" [value]="i"
                  [selected]="stepEmployment === i" (click)="scroll(target);focusTargetEmployment()"
                  (keyup.enter)="scroll(target);focusTargetEmployment()">
                  <div class="is-taller">
                    <div class="level">
                      <div class="width-padding-margin"><span *ngIf="!employmentForm.invalid">
                          <img src="assets/bofa_icon_checkmark2.svg" class="review-icon"
                            alt="check completed employment" role="img" /></span>
                        <span *ngIf="employmentForm.invalid">
                          <img role="img" src="assets/bofa_icon_alert.svg" class="review-icon"
                            alt="error incomplete employment" />
                        </span>
                        <span class="padding-left-10">{{i+1}}</span>
                      </div>
                      <div class="width-margin-left-right"> <span
                          *ngIf="employmentForm.controls.isCurrentEmployer.value=='1'"> (Current) </span></div>
                      <div class="width-max-overflow-white-padding">
                        {{employmentForm.controls.employerName.value}}</div>
                      <div class="width-padding-top-bottom">
                        {{employmentForm.controls.employmentStartDate.value | dateFormat }} <span
                          *ngIf="employmentForm.controls.isCurrentEmployer.value=='0'"> <span
                            *ngIf="employmentForm.controls.employmentEndDate!=null"> -
                          </span>{{employmentForm.controls.employmentEndDate.value | dateFormat }} </span>
                      </div>
                    </div>
                  </div>
                  <mat-divider aria-hidden="true"></mat-divider>
                </mat-list-option>
              </mat-selection-list>
            </div>
            <div class="is-taller padding-top-20">
              <div class="level">
                <div class="width-padding-left"><span *ngIf="hasEmploymentBreakHistory()"
                    class="bofa--heading is-6">Review your employment break
                    history</span>
                </div>
              </div>
            </div>

            <div>
              <mat-selection-list *ngIf="listCheckEmploymentBreak"
                (selectionChange)="handleEmploymentBreakSelection($event, i)">
                <mat-list-option *ngFor="let employmentForm of employmentBreakList.controls; let i = index" [value]="i"
                  [selected]="stepEmploymentBreak === i" (click)="scroll(target2)"
                  (click)="focusTargetEmploymentBreak()" (keyup.enter)="focusTargetEmploymentBreak()"
                  (keyup.enter)="scroll(target2)">
                  <div class="is-taller">
                    <div class="level">
                      <div class="width-padding-left-right-555"><span *ngIf="!employmentForm.invalid">
                          <img src="assets/bofa_icon_checkmark2.svg" class="review-icon"
                            alt="check completed employment break" role="img" /></span>
                        <span *ngIf="employmentForm.invalid">
                          <img src="assets/bofa_icon_alert.svg" class="review-icon"
                            alt="error incomplete employment break" role="img" />
                        </span>
                        <span class="padding-left-10">{{i+1}}</span>
                      </div>
                      <div class="width-margin-left-right"> <span
                          *ngIf="employmentForm.controls.isCurrentEmploymentStatus.value=='1'"> (Current) </span></div>
                      <div class="width-max-overflow-white-padding">
                        {{ getKey(employmentForm.controls.employmentBreakReason.value) }}</div>
                      <div class="width-padding-top-bottom">
                        {{employmentForm.controls.employmentBreakFromDate.value | dateFormat }} <span
                          *ngIf="employmentForm.controls.isCurrentEmploymentStatus.value=='0'"> <span
                            *ngIf="employmentForm.controls.employmentBreakToDate!=null"> -
                          </span>{{employmentForm.controls.employmentBreakToDate.value | dateFormat }} </span>
                      </div>
                    </div>
                  </div>
                  <mat-divider aria-hidden="true"></mat-divider>
                </mat-list-option>
              </mat-selection-list>
            </div>
          </div>
        </div>

        <!-- vertical View -->
        <div *ngIf="employmentChange">
          <div>
            <div class="is-taller  ">
              <div class="level">

                <div class="width-padding-left">
                  <h2 *ngIf="hasEmploymentHistory()" id="review-employment-vertical"
                    class="bofa--heading is-6 flex-text">Review your employment history</h2>
                </div>

                <div class="width-padding-left-305"> <button [disabled]="employmentBreakList.invalid" type="button"
                    class="bofa--button secondary outlined float-padding-margin" #addBreakButtonElement
                    (click)="onAddBreak(); scroll(target2)">Add break</button>
                </div>

                <div class="width-padding-left-305"> <button [disabled]="employmentList.invalid" type="button"
                    class="bofa--button secondary button-font-flex float-padding-margin" #addHistoryButtonElement
                    (click)="onAddEmployer(target); scroll(target)">Add employer</button>
                </div>
              </div>
            </div>
            <div>
              <mat-selection-list *ngIf="listCheckEmploymentHistory"
                (selectionChange)="handleEmploymentSelection($event, i)" aria-describedby="review-employment-vertical">
                <mat-list-option *ngFor="let employmentForm of employmentList.controls; let i = index" [value]="i"
                  [selected]="stepEmployment === i" (click)="scroll(target);focusTargetEmployment()"
                  (keyup.enter)="scroll(target);focusTargetEmployment()">
                  <div class="is-taller min-font">
                    <div class="level">
                      <div class="width-padding-left-right-555"><span *ngIf="!employmentForm.invalid">
                          <img src="assets/bofa_icon_checkmark2.svg" class="review-icon"
                            alt="check completed employment" /></span>
                        <span *ngIf="employmentForm.invalid">
                          <img src="assets/bofa_icon_alert.svg" class="review-icon" alt="error incomplete employment"
                            role="img" />
                        </span>
                        <span class="padding-left-10">{{i+1}}</span>
                      </div>
                      <div class="width-margin-left-right"> <span
                          *ngIf="employmentForm.controls.isCurrentEmployer.value=='1'"> (Current) </span></div>
                      <div class="width-max-overflow-white-padding">
                        {{employmentForm.controls.employerName.value}}</div>
                      <div class="width-padding-top-bottom">
                        {{employmentForm.controls.employmentStartDate.value | dateFormat }} <span
                          *ngIf="employmentForm.controls.isCurrentEmployer.value=='0'"> <span
                            *ngIf="employmentForm.controls.employmentEndDate!=null"> -
                          </span>{{employmentForm.controls.employmentEndDate.value | dateFormat }} </span>
                      </div>
                    </div>
                  </div>
                  <mat-divider aria-hidden="true"></mat-divider>
                </mat-list-option>
              </mat-selection-list>
            </div>

            <div class="padding-top-50" class="is-taller">
              <div class="level">
                <div class="width-padding-left"><span *ngIf="hasEmploymentBreakHistory()"
                    class="bofa--heading is-6">Review your employment break
                    history</span>
                </div>
              </div>
            </div>

            <div>
              <mat-selection-list *ngIf="listCheckEmploymentBreak"
                (selectionChange)="handleEmploymentBreakSelection($event, i)">
                <mat-list-option *ngFor="let employmentForm of employmentBreakList.controls; let i = index" [value]="i"
                  [selected]="stepEmploymentBreak === i" (click)="scroll(target2)"
                  (click)="focusTargetEmploymentBreak()" (keyup.enter)="focusTargetEmploymentBreak()"
                  (keyup.enter)="scroll(target2)">
                  <div class="is-taller  min-font">
                    <div class="level">
                      <div class="width-padding-left-right-555"><span *ngIf="!employmentForm.invalid">
                          <img src="assets/bofa_icon_checkmark2.svg" class="review-icon"
                            alt="check completed employment break" role="img" /></span>
                        <span *ngIf="employmentForm.invalid">
                          <img src="assets/bofa_icon_alert.svg" class="review-icon"
                            alt="error incomplete employment break" role="img" />
                        </span>
                        <span class="padding-left-10">{{i+1}}</span>
                      </div>
                      <div class="width-margin-left-right"> <span
                          *ngIf="employmentForm.controls.isCurrentEmploymentStatus.value=='1'"> (Current) </span></div>
                      <div class="width-max-overflow-white-padding">
                        {{ getKey(employmentForm.controls.employmentBreakReason.value) }}</div>
                      <div class="width-padding-top-bottom">
                        {{employmentForm.controls.employmentBreakFromDate.value | dateFormat }} <span
                          *ngIf="employmentForm.controls.isCurrentEmploymentStatus.value=='0'"> <span
                            *ngIf="employmentForm.controls.employmentBreakToDate!=null"> -
                          </span>{{employmentForm.controls.employmentBreakToDate.value | dateFormat }} </span>
                      </div>
                    </div>
                  </div>
                  <mat-divider aria-hidden="true"></mat-divider>
                </mat-list-option>
              </mat-selection-list>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- needed for skip content off focus -->
    <div *ngIf="noEmploymentHistory.value">
      <div class="unClickableDiv">
        <input tabindex="-1" type="text" class="trasparentText">
      </div>
    </div>
  </form>
</div>


<div *ngIf="jobCountry == 'IND'">
  <mat-divider aria-hidden="true"></mat-divider>
  <div class="flex-change fx-flex-40">
    <h2 class="bofa--heading is-4 flex-heading">Required Documentation</h2>

    <p class="padding_8_16_0 has-no-margin"> </p>
    <a href="/bsiAF/api/downloadOUSParentDocument?ousAttachmentID=59&verifyId={{verifyId}}" target="_blank"
      aria-label="accepted documentation for current employment">
      Accepted Documentation for Current Employment </a>

    <p class="padding_8_16_0 has-no-margin"> </p>
    <a href="/bsiAF/api/downloadOUSParentDocument?ousAttachmentID=60&verifyId={{verifyId}}" target="_blank"
      aria-label="accepted documentation for previous employment">
      Accepted Documentation for Previous Employment </a>

  </div>
</div>


<ng-template #loading>
  Loading Employment history...
</ng-template>